import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Grid } from "@mui/material";
import Fade from "@mui/material/Fade";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";

import PendingIcon from "@mui/icons-material/Pending";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const PodcastDetailCard = (props) => {
  const classes = useStyles();
  return (
    <Fade in={true} timeout={500}>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Box
           
          sx={{
            px: 2,
            py: 2,
            textAlign: "justify",
          }}
        >
          <Card
            className={classes.card}
            sx={{
              boxShadow: 0,
              boxShadow: "4px 4px 10px 0px #CCCCCC",
             
            }}
            onClick={() => {
              props.press();
            }}
          >
            <CardContent
              sx={{
                height: "21vh",
                p: 0,
              }}
            >
              <Box
                hover
                sx={{
                  backgroundColor: "#E6E2FC",
                  color: "primary.main",
                  textAlignLast: "center",
                  px: 2,
                  py: 3,
                  borderRadius: 5,
                  cursor: "pointer",
                 
                }}
              >
                <IconButton sx={{}}>
                  <GraphicEqIcon
                    sx={{
                      fontSize: "1.8rem",
                      color: "#A9A9A9",
                      "@media (min-width: 1636px)": {
                        fontSize: "3rem",
                      },
                    }}
                  />
                </IconButton>
                {/* <Typography className={classes.ModuleNum} sx={{ lineHeight: 1, pt: 1 }}>
                                                    Edit Project
                                                </Typography> */}
              </Box>
              <Box>
                <Grid container sx={{ justifyContent: "space-between" }}>
                  <Box sx={{ maxWidth: "80%" }}>
                    <Tooltip
                      title={props.title ? props.title : ""}
                      placement="top-start"
                    >
                      <Typography
                        className={classes.cardText}
                        color="primary.main"
                      >
                        {props.title ? props.title : ""}
                      </Typography>
                    </Tooltip>
                    <Typography
                      className={classes.className}
                      sx={{
                        paddingBottom: 1,
                      }}
                    >
                      {props.subtitle ? props.subtitle : ""}
                    </Typography>
                  </Box>
                  <Box sx={{ alignContent: "space-evenly" }}>
                    {props.filter == "approvalPending" && (
                      <PendingIcon
                        sx={{
                          fontSize: "1.8rem",
                          color: "#A9A9A9",
                          "@media (min-width: 1636px)": {
                            fontSize: "3rem",
                          },
                        }}
                      />
                    )}
                    {props.filter == "approved" && (
                      <CheckCircleIcon
                        sx={{
                          fontSize: "1.8rem",
                          color: "#00BC12",
                          "@media (min-width: 1636px)": {
                            fontSize: "3rem",
                          },
                        }}
                      />
                    )}
                    {props.filter == "rejected" && (
                      <CancelIcon
                        sx={{
                          fontSize: "1.8rem",
                          color: "#FF0000",
                          "@media (min-width: 1636px)": {
                            fontSize: "3rem",
                          },
                        }}
                      />
                    )}
                  </Box>
                </Grid>
              </Box>
              <Typography
                className={classes.cardText}
                color="primary.main"
                sx={{
                  borderTop: 1,
                  borderColor: "#D9D9D9",
                }}
              >
                {props.primary ? props.primary : ""}
              </Typography>
              <Typography className={classes.className1}>
                {props.secondary ? props.secondary : ""}
              </Typography>
            </CardContent>
            {/* <CardActions sx={{ justifyContent: "flex-end", py: 0, pb: 1 }}>
                                    <IconButton aria-label="Go" size="small" sx={{ borderRadius: '50%', backgroundColor: '#F5F5F5', color: 'primary.main', padding: 0.5 }}>
                                        <NavigateNextIcon fontSize="inherit" sx={{ fontSize: '1.5rem' }} />
                                    </IconButton>
                                </CardActions> */}
          </Card>
        </Box>
      </Box>
    </Fade>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  card: {
   background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%)",
    width: "12rem",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
    padding: "0.5rem",
  },
  card1: {
    backgroundColor: "#fff",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
  },
  card2: {
    borderRadius: 17,
    width: "12rem",
    shadowColor: "#000",
    boxShadow: "2rem",
  },
  cardText: {
    fontSize: "0.75rem",
    paddingTop: 10,
    fontWeight: "900",
    marginLeft: 10,
    marginRight: 10,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  className: {
    borderRadius: 20,
    color: "#DB8829",
    fontSize: "0.70rem",
    marginLeft: 10,
    marginRight: 10,
  },
  className1: {
    borderRadius: 20,
    color: "#828282",
    fontSize: "0.52rem",
    marginLeft: 10,
    marginRight: 10,
  },
});

export default PodcastDetailCard;
